<!--<dialog #modal> -->
<div id="bd"></div>
<div id="modal">
    @if(title) {
    <div class="heading" [ngClass]="type">
        <span class="title">{{title}}</span>
        <button type="button" class="heading-button" (click)="closeDialog()">
            <i class="fa-regular fa-circle-xmark"></i>
        </button>
    </div>
    }
    <div class="body">
        <p [innerHTML]="message"></p>
        <div class="button-bar ral">
            @for(b of buttons; track b) {
            <app-cf-button [type]="b.type" (click)="buttonSelected(b.id)">{{b.text}}</app-cf-button>
            }
        </div>
    </div>
</div>
<!--</dialog>-->